export const CONTROL_PADDING_LEFT = 10;
export const CONTROL_HEIGHT_LG = 100;
export const CONTROL_PADDING_TOP = 5;
export const CONTROL_HEIGHT = 34;
export const CONTROL_BORDER_WIDTH = 1;
export const CONTROL_BORDER_RADIUS = 4;
export const FORM_LABEL_WIDTH = 130;
export const FORM_LABEL_MARGIN = 10;
export const FORM_LABEL_MARGIN_BOTTOM = 5; // от лейбла до контрола
export const FORM_MARGIN = 18;
export const ACTIVE_TAB_UNDERLINE_HEIGHT = 2;
export const AVATAR_BOX_SIZE = 200;

export const CARD_BORDER_RADIUS = 4;
export const CARD_PADDING = 30;
export const CARD_XS_PADDING = 15;
export const ICON_BUTTON_SIZE = 28; // это размеры не самой иконки, а IconButton
export const BUTTON_MARGIN_RIGHT = 10;
export const BUTTON_MARGIN_BOTTOM = 5;
export const FAB_BUTTON_MARGIN_RIGHT = 60;
export const FAB_BUTTON_MARGIN_BOTTOM = 40;

export const COLOURS = {
  // using in Quotes/Budgets (waiting common decision from designers)
  SECONDARY_DEEP_BLUE: '#3853A1',
  SURFACE_HOVER: '#E3E3EB',
  SURFACE_PRIMARY: '#EBEBF2',
  SURFACE_SECONDARY: '#F5F5FA',
  LIGHT_ON_SURFACE_SELECTED: '#DEEFFD',
  ON_SURFACE_SELECTED: '#E0E0E0',
  INPUT_FILLED: '#FAFAFA',

  // design system 2.0
  COCONUT: '#A4A4A8',

  // design system
  BLACK: '#000000',
  WHITE: '#FFFFFF',

  EXTRA_DARK: '#292C2F',
  TEXT: '#47474F',
  GREY_70: '#696970',
  MENUBAR_GREY: '#8C8C92',
  LIGHT_GREY: '#A5A5AB',
  GREY_40: '#BEBFC3',
  LINE_GREY: '#D7DADC',

  PAGE_BACK: '#F0F2F5',
  SECONDARY_NAV_BACK: '#F9F9FB',

  TABLE_GREY_LIGHT: '#F4F5F8',
  TABLE_GREY_DARK: '#E9EBEE',
  TABLE_GREEN_LIGHT: '#C6FDEA',
  TABLE_GREEN_DARK: '#BAF6E1',
  TABLE_RED_LIGHT: '#F7CDD3',
  TABLE_RED_DARK: '#F3C1C8',
  TABLE_MAINTENANCE_LIGHT: '#D6D4E5',
  TABLE_MAINTENANCE_DARK: '#D0CDE1',
  TABLE_OWNER_LIGHT: '#C8E0F7',
  TABLE_OWNER_DARK: '#BDDBF6',
  TABLE_PARKING_LIGHT: '#EAE6E2',
  TABLE_PARKING_DARK: '#E6E1DC',
  TABLE_CREDITNOTE_LIGHT: '#F9E7B8',
  TABLE_CREDITNOTE_DARK: '#F3E2B1',
  TABLE_CHARTER_LIGHT: '#D9EFF0',
  TABLE_CHARTER_DARK: '#D2EAEB',
  TABLE_YELLOW_LIGHT: '#FCF895',
  TABLE_YELLOW_DARK: '#F5F182',

  GREEN_TEXT: '#098C4B',
  GREEN: '#10C66B',
  GREEN_BRIGHT: '#25E083',
  RED_TEXT: '#A90E00',
  RED: '#D31201',
  RED_BRIGHT: '#FF4040',
  MAINTENANCE: '#715BA3',
  MAINTENANCE_LIGHT: '#9687BB',
  OWNER: '#1C96FF',
  OWNER_LIGHT: '#5AB1FC',
  PARKING: '#E5DCCF',
  CREDITNOTE: '#E3C05F',
  CHARTER: '#00CBD3',
  NEW: '#53BADA',
  YELLOW: '#FFDC19',
  PROCESSED: '#5881F7',
  SYS_ACCENT: '#6360EA',

  // benchmark quality
  BENCH_REQUIRES: '#E5003C',
  BENCH_POOR: '#FFE200',
  BENCH_MARKET_AVERAGE: '#A5E200',
  BENCH_GOOD: '#00CF1D',
  BENCH_EXCELLENT: '#00FD00',

  // benchmark categories
  CATEGORY_FUEL: '#1F8CEA',
  CATEGORY_FUELING: '#55D0FD',
  CATEGORY_LUBRICATION: '#BA65FF',
  CATEGORY_FUEL_FEES: '#88FFDF',
  CATEGORY_HANDLING: '#BC2861',
  CATEGORY_PARKING: '#FFFE81',
  CATEGORY_FLIGHT_OPS: '#05C49F',
  CATEGORY_AVIATION_SECURITY: '#F86CDE',
  CATEGORY_CUSTOMS: '#00FFFF',
  CATEGORY_ASSISTANCE: '#C625AA',
  CATEGORY_OTHER: '#FFC400',

  CLEAR: 'transparent',
};

export enum CORE_STATUS {
  NEW = 'new',
  DONE = 'done',
}

export enum SIZE {
  xs = 'xs',
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  xl = 'xl',
}

export const ICON_SIZE = {
  XL: 40,
  LG: 30,
  MD: 24,
  SM: 20,
  XS: 15,
};

export enum BREAKPOINTS {
  XS = 576, // не пользоваться, используется только в модалке
  SM = 768,
  MD = 992,
  LG = 1200,
  LG_MENU = 1400,
  XL = 1920,
}

export const Z_INDEXES = {
  TABLE_HEADER: 50,
  MENU_TABS: 499,
  HEADER: 500,
  MAXIMUM: 999999, // для всего, что должно быть всегда сверху
};

export const HEIGHT_SIZE = {
  headerHeight: 48,
  tabsHeight: 40,
};

export const lightenDarkenColor = (
  col: string,
  amt: number,
  alpha: number = 1
): string => {
  // взял код из инета
  let usePound = false;

  if (col[0] === '#') {
    // eslint-disable-next-line no-param-reassign
    col = col.slice(1);
    usePound = true;
  }
  const num = parseInt(col, 16);

  let r = (num >> 16) + amt;

  if (r > 255) {
    r = 255;
  } else if (r < 0) {
    r = 0;
  }

  let b = ((num >> 8) & 0x00ff) + amt;

  if (b > 255) {
    b = 255;
  } else if (b < 0) {
    b = 0;
  }

  let g = (num & 0x0000ff) + amt;

  if (g > 255) {
    g = 255;
  } else if (g < 0) {
    g = 0;
  }

  const hex = (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16);
  return colorWithAlpha(hex, alpha);
};

export const colorWithAlpha = (hex: string, alpha: number): string => {
  const red = parseInt(hex.slice(1, 3), 16);
  const green = parseInt(hex.slice(3, 5), 16);
  const blue = parseInt(hex.slice(5, 7), 16);

  return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
};

export const centerCellFunc = (margin = 5) => {
  // когда по центру нужно выравнять с марджином небольшим
  return {
    display: 'flex',
    alignItems: 'center',
    '&>*': {
      marginRight: margin,
      '&:last-child': {
        marginRight: 0,
      },
    },
  };
};

export const centerCell = centerCellFunc();
